
import './App.css';
import { router, } from "./Pages/index";
import { RouterProvider } from "react-router-dom";
import ErrorBoundary from './Components/ErrorBoundary/ErrorBoundary';
import CacheManager from './Components/CacheManager/CacheManager';

function App() {

  return (
    <ErrorBoundary>
      <CacheManager>
        <RouterProvider router={router} />
      </CacheManager>
    </ErrorBoundary>
  );
}

export default App;
